import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateRangeComponent } from './date-range.component';
import { DateModule } from '../date/date.module';
import { CheckboxFieldModule } from "libraries/module/formbuilder/fields/checkbox-field/checkbox-field.module";

@NgModule({
    imports: [
        CommonModule,
        DateModule,
        FormsModule,
        ReactiveFormsModule,
        //TODO NG UPGRADE NgxErrorsModule,
        CheckboxFieldModule,
    ],
    exports: [DateRangeComponent],
    declarations: [DateRangeComponent],
    providers: [],
})
export class DateRangeModule { }
